import { Modal, ModalBody, Text, ModalCloseButton } from '@chakra-ui/react';
import {
  CustomModalContent,
  CustomModalHeader,
  CustomModalOverlay,
} from './Modal';
import { useIsMobile } from '../hooks/useMobile';
import { colors } from '../theme';

const InValidAddressModal = ({
  isOpen,
  onExit,
  gameAddress,
  connectAddress,
}: any) => {
  const { isMobile } = useIsMobile();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onExit}
      closeOnEsc={true}
      closeOnOverlayClick={true}
      isCentered
      size={'xl'}
    >
      <CustomModalOverlay />
      <CustomModalContent
        width={isMobile ? '30rem' : '35rem'}
        px={isMobile ? '0' : ''}
      >
        <CustomModalHeader>Invalid address</CustomModalHeader>
        <ModalCloseButton />
        <ModalBody
          mb={4}
          fontSize={'md'}
          color={colors['c-103']}
          lineHeight={'2rem'}
        >
          The address used to join the game is{' '}
          <Text color={colors.brand}>{gameAddress}</Text>, but the connected
          address is <Text color={'red'}>{connectAddress}</Text>. Please switch
          to address <Text color={'white'}>{gameAddress}</Text>
          before proceeding.
        </ModalBody>
      </CustomModalContent>
    </Modal>
  );
};

export default InValidAddressModal;
